module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "OT"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gonzalez_The_Story_Luke_Tells_text_CC3#_idTOCAnchor-1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gonzalez_The_Story_Luke_Tells_text_CC4#_idTOCAnchor-2"
    }
  }, [_vm._v("1. Luke and the History of Humankind")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gonzalez_The_Story_Luke_Tells_text_CC5#_idTOCAnchor-3"
    }
  }, [_vm._v("2. Luke and the History of Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gonzalez_The_Story_Luke_Tells_text_CC6#_idTOCAnchor-4"
    }
  }, [_vm._v("3. Luke and the Great Reversal")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gonzalez_The_Story_Luke_Tells_text_CC7#_idTOCAnchor-5"
    }
  }, [_vm._v("4. Luke and Gender")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gonzalez_The_Story_Luke_Tells_text_CC8#_idTOCAnchor-6"
    }
  }, [_vm._v("5. Luke and Salvation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gonzalez_The_Story_Luke_Tells_text_CC9#_idTOCAnchor-7"
    }
  }, [_vm._v("6. Food and Drink in Luke’s Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gonzalez_The_Story_Luke_Tells_text_CC10#_idTOCAnchor-8"
    }
  }, [_vm._v("7. Luke and Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gonzalez_The_Story_Luke_Tells_text_CC11#_idTOCAnchor-9"
    }
  }, [_vm._v("8. Luke and the Holy Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gonzalez_The_Story_Luke_Tells_text_CC12#_idTOCAnchor-10"
    }
  }, [_vm._v("Conclusion: Luke’s Open Invitation")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-477d088a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gonzalez_The_Story_Luke_Tells_text_CC-1.vue
// module id = 60
// module chunks = 0